const LAST_MAIN_ROUTE_KEY = 'jiuda:lastMainRoute'

const ALLOWED_MAIN_PATHS = new Set([
  '/main',
  '/main/formula',
  '/main/projects',
  '/main/recent-formula',
  '/main/recent-shares',
  '/main/share-inbox',
  '/main/ProductLibrary',
  '/main/template-community',
  '/main/RecycleBin',
])

const ALLOWED_ADMIN_PATH_PREFIX = '/admin'

const firstString = (value: unknown): string => {
  if (Array.isArray(value)) return typeof value[0] === 'string' ? value[0] : ''
  return typeof value === 'string' ? value : ''
}

export const normalizeReturnPath = (value: unknown, fallback = '/main/formula'): string => {
  let raw = firstString(value).trim()
  if (!raw) return fallback

  try {
    raw = decodeURIComponent(raw)
  } catch {
    // 保留原值继续做安全校验
  }

  // 兼容完整 URL 或 hash URL，例如 http://xxx/#/main/projects
  const hashIndex = raw.indexOf('#')
  if (hashIndex >= 0) {
    raw = raw.slice(hashIndex + 1)
  }

  if (!raw.startsWith('/')) return fallback

  const pathOnly = raw.split('?')[0].split('#')[0]
  if (ALLOWED_MAIN_PATHS.has(pathOnly)) return raw
  if (pathOnly === ALLOWED_ADMIN_PATH_PREFIX || pathOnly.startsWith(`${ALLOWED_ADMIN_PATH_PREFIX}/`)) return raw

  return fallback
}

export const saveLastMainRoute = (path: unknown): void => {
  if (typeof window === 'undefined') return
  const normalized = normalizeReturnPath(path, '')
  if (!normalized || !normalized.startsWith('/main')) return

  try {
    window.localStorage.setItem(LAST_MAIN_ROUTE_KEY, normalized)
  } catch {
    // 忽略浏览器隐私模式或存储不可用场景
  }
}

export const getLastMainRoute = (fallback = '/main/formula'): string => {
  if (typeof window === 'undefined') return fallback

  try {
    return normalizeReturnPath(window.localStorage.getItem(LAST_MAIN_ROUTE_KEY), fallback)
  } catch {
    return fallback
  }
}
